import Main from './ManageCookiesMain'

const ManageCookies = {
  Main,
}

export default ManageCookies
